export const HOME_QUERY = `
  query HomeQuery {
    homepage {
      dashboardId
      schemaVersion
      widgets {
        id
        __typename
        type
        title
        size
        ... on WeatherWidget {
          settings {
            day
            display_label
            id
            location_id
            provider
            unit
            user_id
          }
        }
      }
    }
  }`;
